module.exports = __webpack_public_path__ + "img/beer-mug-empty.d20043ea.svg";